<ng-container *transloco="let t">
  <div class="padding-20" fxFlex>
    <div *ngIf="isLoader" class="org-loader">
      <mat-progress-spinner mode="indeterminate" diameter="50" color="primary"></mat-progress-spinner>
      <p>Loading Users...</p>
    </div>
    <div fxLayout="row wrap" fxLayoutGap.gt-xs="20px">
      <div fxFlex fxFlex.xs="100" class="details-card">
        <mat-tab-group #tabGroup (selectedTabChange)="tabChanged($event)">
          <mat-tab label="{{ t('user.User') }}">
            <mat-card class="no-padding">
              <div fxLayout="row">
                <div fxFlex>
                  <form class="details-card-content user-mgmt-ctrl" fxLayout="row wrap" fxLayoutAlign="start center"
                    [formGroup]="searchForm" (ngSubmit)="onSearch()" style="padding-bottom: 0px;">
                    <div fxFlex fxFlex.sm="50" fxFlex.xs="100" class="form-control">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ t("user.UserName") }}</mat-label>
                        <input matInput formControlName="userName" />
                      </mat-form-field>
                    </div>
                    <div fxFlex fxFlex.sm="50" fxFlex.xs="100" class="form-control">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ t("user.Email") }}</mat-label>
                        <input matInput formControlName="email" />
                      </mat-form-field>
                    </div>
                    <div fxFlex fxFlex.sm="50" fxFlex.xs="100" class="form-control">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ t("siteDetails.status") }}</mat-label>
                        <mat-select formControlName="active">
                          <mat-option [value]="null">-- Select --</mat-option>
                          <mat-option *ngFor="let option of statusList" [value]="option.id">{{ option.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div fxFlex fxFlex.sm="50" fxFlex.xs="100" class="form-control">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ t("user.DepartmentName") }}</mat-label>
                        <input matInput formControlName="departmentName" />
                      </mat-form-field>
                    </div>
                    <div fxFlex="10" fxFlex.sm="50" fxFlex.xs="100" fxLayout="row" fxLayoutAlign="end center"
                      class="form-control button-group">
                      <button mat-icon-button color="primary" type="submit" class="sml-button">
                        <mat-icon>search</mat-icon>
                      </button>
                      <button mat-icon-button class="sml-button">
                        <mat-icon (click)="reset()">refresh</mat-icon>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div class="grid">
                <div fxHide fxShow.gt-sm style="padding: 0 20px;">
                  <button mat-icon-button color="primary" (click)="openUserAddDialog()"  matTooltip="Add User">
                    <mat-icon>person_add</mat-icon>
                  </button>
                  <button mat-icon-button color="primary" (click)="exportToExcel()" matTooltip="Export Users to Excel"
                    matTooltipPosition="below">
                    <img src="/assets/images/export-to-excel.svg"  alt="Excel" width="24" height="24">
                  </button>
                </div>
                <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="propcentra-grid"
                  *ngIf="hasRows" style="padding-top: 0px;">
                  >
                  <!-- <ng-container matColumnDef="userName">
                    <mat-header-cell *matHeaderCellDef>
                      {{ t("user.UserName") }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <div class="mobile-label">
                      {{  t('user.UserName') }}
                    </div>
                      <div>{{ element.userName }}</div>
                    </mat-cell>
                  </ng-container> -->
                  <ng-container matColumnDef="firstName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ t("user.Name") }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <div class="mobile-label">
                        {{ t('user.Name') }}
                      </div>
                      <div>{{ element.firstName }}</div>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="arabicName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ t("user.Name") }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <div class="mobile-label">
                        {{ t("user.Name") }}
                      </div>
                      <div>{{ element.arabicName }}</div>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="email">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ t("user.Email") }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <div class="mobile-label">
                        {{ t("user.Email") }}
                      </div>
                      <div>{{ element.email }}</div>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="departmentName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ t("user.DepartmentName") }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <div class="mobile-label">
                        {{ t("user.DepartmentName") }}
                      </div>
                      <div>{{ element.departmentName }}</div>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="statusType">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ t("siteDetails.status") }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <div class="mobile-label">
                        {{ t("siteDetails.status") }}
                      </div>
                      <div>{{ element.statusType }}</div>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef>
                      Actions
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                      <button mat-icon-button (click)="onUserEdit(row)" class="edit-btn">
                        <mat-icon>edit</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row (click)="onRowClick(row)" *matRowDef="let row; columns: displayedColumns"></mat-row>
                </mat-table>
                <mat-paginator *ngIf="hasRows" [pageIndex]="pageIndex" [length]="totalLength" [pageSize]="pageSize"
                  (page)="page($event)" [hidePageSize]="true">
                </mat-paginator>
                <div class="no-records-found" *ngIf="!hasRows" fxLayout="column" fxLayoutAlign="center center">
                  <mat-icon aria-label="No User Found">search</mat-icon>
                  <p>{{ t("noRecordsFound") }}</p>
                </div>
              </div>
            </mat-card>
          </mat-tab>
          <mat-tab label="{{ t('user.Role') }}">
            <app-role-list (selectedRoleToEmit)="selectedRoleParent($event)" #roleList></app-role-list>
          </mat-tab>
        </mat-tab-group>
      </div>
      <div fxFlex="25" fxFlex.xs="100" class="details-card mt20-xs">
        <div class="role-container" *ngIf="selectedTab == 0">
          <div fxLayout="column">
            <!-- <div class="user-info" fxLayoutAlign="center center">
              <h3>{{ selectedUser?.firstName }}</h3>
              <h4>{{ selectedUser?.arabicName }}</h4>
            </div> -->
            <div class="user-info-detail padding-10" fxLayout="column">
              <div fxFlex class="padding-top-bottom-5" *ngIf="selectedUser">
                <label class="label-gray-hedding">{{ t("user.Name") }}</label><br />
                <label class="label-sub-content">
                  {{
                  layoutQuery.layoutState.language.code === "en"
                  ? selectedUser.firstName
                  : selectedUser.arabicName
                  }}
                </label>
              </div>

              <div fxFlex class="padding-top-bottom-5" *ngIf="selectedUser">
                <label class="label-gray-hedding">{{ t("user.Email") }}</label><br />
                <label class="label-sub-content">{{
                  selectedUser.email
                  }}</label>
              </div>
              <div fxFlex class="padding-top-bottom-5" *ngIf="selectedUser">
                <label class="label-gray-hedding">{{
                  t("user.MobileNo")
                  }}</label><br />
                <label class="label-sub-content">{{
                  selectedUser.phoneNumber
                  }}</label>
              </div>

              <mat-tab-group>
                <mat-tab label="ACCESS">
                  <div fxFlex class="padding-top-bottom-5">
                    <label class="label-sub-content">{{
                      t("role.assignedRoles")
                      }}</label>
                  </div>
                  <div fxFlex class="padding-top-bottom-5 user-access-chips-list">
                    <mat-chip-set aria-label="Role selection">
                      <mat-chip *ngFor="let role of selectedUserRoles">{{ role }}
                      </mat-chip>
                      <mat-chip color="primary" selected (click)="openUserRoleAssignDialog()" class="assign-role-chip"
                        style="background-color: #ea7600; color: white;" *ngIf="selectedUser" matTooltip="Add Role">{{
                        t("role.assignRole") }}</mat-chip>
                    </mat-chip-set>
                  </div>
                  <div fxFlex class="padding-top-bottom-5">
                    <label class="label-sub-content">{{
                      t("role.assignedModules")
                      }}</label>
                  </div>
                  <div fxFlex class="padding-top-bottom-5 user-access-chips-list">
                    <mat-chip-set aria-label="Role selection">
                      <mat-chip *ngFor="let module of selectedUserModules">{{ module.title }}
                      </mat-chip>
                    </mat-chip-set>
                  </div>
                </mat-tab>
                <mat-tab label="DETAILS">
                  <div fxFlex class="padding-top-bottom-5" *ngIf="selectedUser">
                    <label class="label-gray-hedding">{{
                      t("user.DepartmentName")
                      }}</label><br />
                    <label class="label-sub-content">{{
                      selectedUser.departmentName
                      }}</label>
                  </div>
                  <div fxFlex class="padding-top-bottom-5" *ngIf="selectedUser">
                    <label class="label-gray-hedding">{{
                      t("user.Designation")
                      }}</label><br />
                    <label class="label-sub-content">{{
                      selectedUser.designation
                      }}</label>
                  </div>
                  <div fxFlex class="padding-top-bottom-5" *ngIf="selectedUser">
                    <label class="label-gray-hedding">{{
                      t("user.createdBy")
                      }}</label><br />
                    <label class="label-sub-content">{{
                      selectedUser.createdBy
                      }}</label>
                  </div>
                  <div fxFlex class="padding-top-bottom-5" *ngIf="selectedUser">
                    <label class="label-gray-hedding">{{
                      t("user.createdDate")
                      }}</label><br />
                    <label class="label-sub-content">{{
                      selectedUser.dateCreated
                      }}</label>
                  </div>

                </mat-tab>
              </mat-tab-group>
            </div>
          </div>
        </div>
        <div class="role-container" *ngIf="selectedTab == 1">
          <div fxLayout="column">
            <div class="user-info" fxLayoutAlign="center center" style="background-color: #ea7600;">
              <h3 style="font-weight: 500px; color: white;">{{ selectedRole.name }}</h3>
            </div>
            <div class="user-info-detail padding-10" fxLayout="column">
              <div fxFlex class="padding-top-bottom-5">
                <label class="label-gray-hedding">{{
                  t("role.description")
                  }}</label><br />
                <label class="label-sub-content">{{
                  selectedRole.description
                  }}</label>
              </div>
              <div fxFlex class="padding-top-bottom-5">
                <label class="label-sub-content">{{
                  t("user.assignedUsers")
                  }}</label>
              </div>
              <div fxFlex class="padding-top-bottom-5 user-access-chips-list">
                <mat-chip-set aria-label="Assigning Role">
                  <mat-chip *ngFor="let user of usersByRole">{{ user?.userName }}
                  </mat-chip>
                  <mat-chip color="primary" selected (click)="openRoleUserAssignDialog()" class="assign-role-chip"
                    style="background-color: #ea7600; color: white;" matTooltip="Add User" *ngIf="selectedUser">{{
                    t("user.assignToUsers") }}</mat-chip>
                </mat-chip-set>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>